<div class="container">
  <div class="backdrop">
    <div class="terms__container">
      <img src="assets/icons/x.svg" class="close" (click)="closeTerms()">
      <p class="header">Términos y condiciones</p>
      <div class="terms" [innerHTML]="termsService.terms">
      </div>
    </div>
  </div>
</div>